// extracted by mini-css-extract-plugin
module.exports = {"quote":"Header_quote__1KeDq"};